var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"function-button",class:{
    'is-rectangle': _vm.isRectangle,
    'left-style': _vm.isLeftColumn,
    'right-style': !_vm.isLeftColumn
  },style:({ height: _vm.height || _vm.defaultHeight })},[_c('span',{staticClass:"button-title"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"button-icon",attrs:{"src":_vm.icon,"alt":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }